import React, { useEffect, useState } from 'react';
import { ThemeProvider, Box, Typography, Grid2 } from '@mui/material';
import { theme } from '../../Medical_History_Forms/themeprovider';
import { useLoader } from '../../loaderProvider/loader';
import { infoTextStyle, sectionTitleStyle } from '../../../utils/commonUtils';
import { getEmbryoTransfer,  } from './embryoTransfer.helpers';
import { MasterconfigrutationDetails } from '../oocyteRetrieval/OocyteRetrival.helper';

interface EmbryoTransferDetailsProps {
  cycleId: number | null;
  dropDownOptions?: MasterconfigrutationDetails;
 
}

const EmbryoTransferDetails: React.FC<EmbryoTransferDetailsProps> = ({ cycleId,dropDownOptions}) => {
  const { showLoader, hideLoader } = useLoader();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [transferData, setTransferData] = useState<any>(null); // Adjust type as needed

  useEffect(() => {
    if (!cycleId) return;

    showLoader();
    getEmbryoTransfer(cycleId)
      .then((data) => setTransferData(data))
      .catch(() => {
        // setTransferData(defaultEmbryoTransferData); // Default data on error
        setTransferData([]);
      })
      .finally(() => hideLoader());
  }, [cycleId, showLoader, hideLoader]);

  const renderField = (label: string, value: string | number | null | undefined) => {
    if (!value) return null;

    return (
      <Grid2 size={{ xs: 4, sm: 4, md: 4, lg: 3 }}>
        <Typography variant="body1" sx={sectionTitleStyle}>{label}</Typography>
        <Typography variant="body2" sx={infoTextStyle}>{value}</Typography>
      </Grid2>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ p: 3 }}>
        <Grid2 container spacing={4} mb={3}>
          {renderField('Transfer Method', dropDownOptions?.transfer_method.find(item => item.value === transferData?.transfer_method)?.label)}
          {renderField('Oocyte Fertilized', transferData?.oocyte_fertilized_method)}
          {renderField('Embryo Cryopreserved', transferData?.embryo_cryo_preservation_method)}
          {renderField('Fresh Transfer', transferData?.fresh_embryo_transfer_method)}
          {renderField('Frozen Transfer', transferData?.frozen_embryo_transfer_method)}
          {renderField('Date', transferData?.date)}
          {renderField('Start Time', transferData?.start_time)}
          {renderField('End Time', transferData?.end_time)}
          {renderField('ET Dish ID', transferData?.et_dish_id)}
          {renderField('Embryologist', transferData?.embryologist_name)}
          {renderField('Witness Embryologist', transferData?.witness_embryologist_name)}
          {renderField('Nurse', transferData?.nurse_name)}
          {renderField('Performed Under Anesthesia', transferData?.performed_under_anesthesia ? 'Yes' : 'No')}
          {renderField('Anesthesia', dropDownOptions?.embryo_Anesthesia.find(item => item.value === transferData?.anesthesia)?.label)}
          {renderField('Anesthetist', transferData?.anesthetist_name)}
          {renderField('Endometrium Thickness (mm)', transferData?.endometrium_thickness)}
          {renderField('Endometrium Pattern', dropDownOptions?.endometrium_pattern.find(item => item.value === transferData?.endometrium_pattern)?.label)}
          {renderField('Ultrasound', transferData?.is_ultrasound ? 'Yes' : 'No')}
          {renderField('Ultrasound Method', dropDownOptions?.ultrasound_method.find(item => item.value === transferData?.ultrasound_method)?.label)}
          {renderField('Transfer Depth', transferData?.transfer_depth)}
          {renderField('Level of Difficulty', dropDownOptions?.embryoDifficulty_level.find(item => item.value === transferData?.difficulty_level)?.label)}
          {renderField('Catheter', dropDownOptions?.catheter.find(item => item.value === transferData?.catheter)?.label)}
          {renderField('Catheter Tube', transferData?.catheter_tube)}
          {renderField('Catheter Remarks', transferData?.catheter_remarks)}
          {renderField('No of Attempts', transferData?.no_of_attempts)}
          {renderField('Distance From Fundus (cm)', transferData?.distance_from_fundus)}
          {renderField('Embryo Retained', transferData?.embryo_retained)}
          {renderField('Use Of Stylet', transferData?.is_stylet_used ? 'Yes' : 'No')}
          {renderField('Use Of Tenaculum', transferData?.is_tenaculum_used ? 'Yes' : 'No')}
          {renderField('Use Of Embryo Glue', transferData?.is_embryo_glue_used ? 'Yes' : 'No')}
          {renderField('Complications', transferData?.complications)}
          {renderField('Set Pregnancy Date', transferData?.pregnancy_date)}
          {renderField('Cycle Close', transferData?.is_cycle_closed ? 'Yes' : 'No')}
          {renderField('Cycle Close Reason', transferData?.cycle_close_reason)}
          {renderField('Notes', transferData?.notes)}
        </Grid2>
      </Box>
    </ThemeProvider>
  );
};

export default EmbryoTransferDetails;
